var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStale = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 17,
  viewBox: "0 0 17 17",
  width: 17,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.344238.938965h16v16h-16z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.5361 6.8981h3.9592m0-3.95914v3.95756"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.5427 6.49205c-1.0707-2.35536-3.4696-4.05309-6.19749-4.05309-3.58985 0-6.5 2.91015-6.5 6.5 0 3.58984 2.91015 6.50004 6.5 6.50004 2.08129 0 3.93419-.9783 5.12389-2.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 5v4l2.5 1.5"
}))));
export default SvgStale;